import { useState } from 'react';

const parseData = (data: any) => {
  if (!data) {
    return data;
  }
  if (typeof data === 'string') {
    return JSON.parse(data);
  }
};
const useLocalStorageState = (key: string) => {
  const [data, setData] = useState(parseData(localStorage.getItem(key)));

  const _setData = (value: any) => {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
    return setData(value);
  };

  return [data, _setData];
};
export default useLocalStorageState;
